import script from "./ExRegSerAero.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExRegSerAero.vue?vue&type=script&setup=true&lang=ts"

import "./ExRegSerAero.vue?vue&type=style&index=0&id=7c031dc6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c031dc6"]])

export default __exports__